import {Route, Routes, useParams} from "react-router-dom"

import OrganizationOverview from "./OrganizationOverview"
import React, {useEffect} from "react";
import {logging} from "@/utils/functions";
import {LoadingBackdrop} from "@/components/Layout/DefaultLayout";

export default function Organization({customer, user, invitation}: any) {
    const params = useParams();
    const active = params['*'] || ''

    const context = {
        customer,
        user,
        invitation
    }

    useEffect(() => {
        logging('OrganizationOverview ▶ ActiveParams', active)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <React.Suspense fallback={<LoadingBackdrop/>}>
            <Routes>
                <Route path="" element={<OrganizationOverview {...context} />}/>
                <Route path="teams/invitation" element={<OrganizationOverview {...context} />}/>
            </Routes>
        </React.Suspense>
    )
}